import Vue from 'vue';
import Router from 'vue-router';
import store from 'store/store';
import Home from './home.router';
import TermtermIconList from './termIconList.router';
import Term from './term.router';
import TermReport from './termReport.router';
import ImportCenter from './termImportCenter.router';
import ImportHistory from './termImportHistory.router';
import Place from './place.router';
import Form from './form.router';
import User from './user.router';
import Settings from './settings.router';
import TradutorDB from './tradutorDB.router';
import SaleManagement from './saleManagement.router';
import Distributors from './distributors.router';
import Importation from './importation.router';
import ChipTimelife from './chipTimelife.router';
import RegularSend from './regularSend.router';
import Goals from './goals.router';
import Gateway from './gateway.router';
import ExportBases from './exportBases.router';
import ChipTracking from './chipTracking.router';
import AnalyticalReport from './analyticalReport.router';
import MeuPainelSigTim from './meupainel.sigtim.router';
import PowerBiSigTim from './powerbi.sigtim.router';
import PowerBiVisita from './powerbi.visita.router';
import RedirectIconListSigtim from './redirectIconListSigtim.router';
import RedirectIconListVisits from './redirectIconListVisits.router';
import HelpDesk from './helpDesk.router';
import baselineImportation from './baselineImportation.routes';
import transationTracking from './transationTracking.router';
import DeParaFaturamento from './DeParaFaturamento.router';
import Nuvem from './nuvem.router';
import gu from './gu.router';
import privacyPolicy from './privacyPolicy.router';
import SS360AtitudeAzul from './SS360-AtitudeAzul.router';
import KM from './km.router';
import settings from './settings.router';

import PowerBiRoles from './powerbi.roles.router';
import RedirectIconListRoles from './roles.router';

import HomeBrokerMain from './HomeBrokerMain.router';

import PDV from './pdv.router';
import PdvImportCenter from './pdv.router';
import PdvImportHistory from './pdv.router';

import PowerBiPDV from './powerbi.pdv.router';

import ManualDeDb from './bpo.sigtim.router';
import ImportManualDb from './bpo.sigtim.router';
import ImportManualDeDb  from './bpo.sigtim.router';
import HistoryImportDb from './bpo.sigtim.router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    Home,
    SS360AtitudeAzul,
    {
      path: '/dashboard',
      component: () => import('views/Base.vue'),
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: () => import('modules/dashboard/Dashboard.vue')
        },
        privacyPolicy,
        Goals,
        Place,
        Form,
        User,
        Settings,
        TradutorDB,
        SaleManagement,
        Term,
        TermtermIconList,
        TermReport,
        ImportCenter,
        ImportHistory,
        Distributors,
        Importation,
        ChipTimelife,
        RegularSend,
        Gateway,
        MeuPainelSigTim,
        PowerBiSigTim,
        PowerBiVisita,
        ExportBases,
        ChipTracking,
        AnalyticalReport,
        RedirectIconListSigtim,
        RedirectIconListVisits,
        Nuvem,
        gu,
        RedirectIconListVisits,
        HelpDesk,
        baselineImportation,
        transationTracking,
        DeParaFaturamento,
        HomeBrokerMain,
        KM,
        settings,
        RedirectIconListRoles,
        PowerBiRoles,
        PDV,
        PdvImportCenter,
        PdvImportHistory,
        PowerBiPDV,
        ManualDeDb,
        ImportManualDb,
        ImportManualDeDb,
        HistoryImportDb
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition || to.meta.savePositionFrom === from.name) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.breadcrumbs) {
    store.dispatch('breadcrumbs/setItems', to.meta.breadcrumbs);
  }

  function getModuleName() {
    let path = '';

    if (to.meta.breadcrumbs) {
      path = to.meta.breadcrumbs[1].text;

      switch (path) {
        case 'venda cantada':
        case 'Venda Cantada':
          return 'venda_cantada'

        case 'termo contingencial':
        case 'Termo Contingencial':
          return 'termo';

        case 'controle gu':
        case 'Controle GU':
          return 'gu';

        default:
          return path.toLowerCase();
      }
    }

    path = 'dashboard';
    return path.toLowerCase();
  }

  if (store.state.auth.user) {
    store.dispatch('accessTracking/fetchAccessTracking', {
      name: getModuleName(to.fullPath),
      token: window.localStorage.getItem('token'),
    })

    next();
    return;
  }

  const notAuth = to.matched.some(match => match.meta.notAuth);

  if (notAuth) {
    next();
  } else {
    store
      .dispatch('auth/verifyAccess')
      .then(() => next())
      .catch(() => {
        if (store.state.auth.user) {
          next({
            name: 'Dashboard'
          });
        } else {
          next({
            name: 'Login'
          });
        }
      });
  }
});

export default router;
